import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../../hooks/useLoader";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  FormOperacionCorporateLending, FormOperacionCorporateLendingDetalle,
  schemaFormOperacionCorporateLending, schemaFormOperacionCorporateLendingDetalle
} from "./types/types";
import { OperacionCorporateLendingDetalleFields, OperacionCorporateLendingFields } from "./types/fields";
import SeccionCorporateLendingDatosOperacion from "./components/SeccionCorporateLendingDatosOperacion";
import { Box, Grid } from "@mui/material";
import toast from "react-hot-toast";
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import SeccionCorporateLendingDetalleNuevo from "./components/SeccionCorporateLendingDetalleNuevo";
import { HttpCorporateLending } from "./api/httpCorporateLending";
import CardActions from "../../components/CardActions";
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion';

const defaultValues: FormOperacionCorporateLendingDetalle = {
  [OperacionCorporateLendingDetalleFields.Deudor]: "Default Deudor",
  [OperacionCorporateLendingDetalleFields.Acreedor]: "Default Acreedor",
  [OperacionCorporateLendingDetalleFields.Moneda]: "USD",
  [OperacionCorporateLendingDetalleFields.Monto]: '1000',
  [OperacionCorporateLendingDetalleFields.Destino]: "Default Destino",
  [OperacionCorporateLendingDetalleFields.PlazoDisponibilidad]: "12 months",
  [OperacionCorporateLendingDetalleFields.Plazo]: "12 months",
  [OperacionCorporateLendingDetalleFields.Amortizacion]: "Default Amortizacion",
  [OperacionCorporateLendingDetalleFields.Comision]: "Default Comision",
  [OperacionCorporateLendingDetalleFields.Precancelacion]: "Default Precancelacion",
  [OperacionCorporateLendingDetalleFields.TasaInteres]: '5.5',
  [OperacionCorporateLendingDetalleFields.FrecuenciaInteres]: "Monthly",
  [OperacionCorporateLendingDetalleFields.FiadorAvalista]: "Default Fiador/Avalista",
  [OperacionCorporateLendingDetalleFields.Garantias]: "Default Garantias",
  [OperacionCorporateLendingDetalleFields.Pagare]: "Default Pagare",
  [OperacionCorporateLendingDetalleFields.Covenants]: "Default Covenants",
  [OperacionCorporateLendingDetalleFields.Ley]: "Default Ley",
  [OperacionCorporateLendingDetalleFields.FechaEjecucion]: new Date(),
  id: -1, // Assuming schemaEntityWithId adds an id field
};

type NuevoSistemaCorporateLendingProps = {
  codSistemaPrincipal: number
}

function NuevoSistemaCorporateLending(props: NuevoSistemaCorporateLendingProps) {
  const { setSendPromise } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo);

  const { submitOperacion } = useSubmitOperacion();

  const [detalleProvisional, setDetalleProvisional] = useState<FormOperacionCorporateLendingDetalle>();

  const formMethods = useForm<FormOperacionCorporateLending>({
    resolver: zodResolver(schemaFormOperacionCorporateLending),
    defaultValues: {
      [OperacionCorporateLendingFields.CodPais]: props.codSistemaPrincipal,

    }
  });

  const detalleFormMethods = useForm<FormOperacionCorporateLendingDetalle>({
    resolver: zodResolver(schemaFormOperacionCorporateLendingDetalle),

    defaultValues: {
      id: -1,
    }
  });

  const alCrearOperacionCorporateLending = useCallback((data: FormOperacionCorporateLending, selected: number) => {
    detalleFormMethods.handleSubmit((detalleData) => {
      setDetalleProvisional(detalleData);

      const payload = {
        ...data,
        [OperacionCorporateLendingFields.Detalle]: detalleData,
        [OperacionCorporateLendingFields.Envio]: selected !== 1,
        codPais: props.codSistemaPrincipal
      };

      submitOperacion(payload, {
        apiCall: HttpCorporateLending.post,
        successMessage: 'Guardado correctamente.',
      });
    })();
  }, [detalleFormMethods, submitOperacion, props.codSistemaPrincipal, setDetalleProvisional]);

  useEffect(() => {
    let onSend = () => console.log('on send test');

    onSend = () => formMethods.handleSubmit(data => alCrearOperacionCorporateLending(data, 2));

    setSendPromise(onSend);
  }, [formMethods, alCrearOperacionCorporateLending]);

  return (
    <Box>
      <Grid container spacing={4}>
        <CardActions title='Datos Operación' colapsable>
          <Grid item xs={12}>
            <SeccionCorporateLendingDatosOperacion
              formMethods={formMethods}
              codSistemaPrincipal={props.codSistemaPrincipal}
              nuevo
            />
          </Grid>
          <Grid item xs={12}>
            <SeccionCorporateLendingDetalleNuevo
              codPais={props.codSistemaPrincipal}
              detalleProvisional={detalleProvisional}
              setDetalleProvisional={setDetalleProvisional}
              formMethods={detalleFormMethods}
            />
          </Grid>
        </CardActions>
      </Grid>
    </Box>
  );
}

export default NuevoSistemaCorporateLending;